import { render, staticRenderFns } from "./SubjectCard.vue?vue&type=template&id=2e8b1e88&scoped=true&"
import script from "./SubjectCard.ts?vue&type=script&lang=js&"
export * from "./SubjectCard.ts?vue&type=script&lang=js&"
import style0 from "./SubjectCard.css?vue&type=style&index=0&id=2e8b1e88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8b1e88",
  null
  
)

export default component.exports